import { useState, useEffect } from 'react';
import axios from 'axios';

import * as Icons from '../../../images/icons/icons_component';
import * as Theme from '../../../images/icons/icons_theme';

function OperCmit_popup() {

    const [data, setData] = useState({});
    const [emogList, setEmogList] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('operCmitData')) || {};
    const [fileFlag, setFileFlag] = useState(sendData.ATCH_DTA !== 'undefined' && sendData.ATCH_DTA ? "Y" : "F");

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/operrslt/opercmitOperrsltDetail.do', {
                params: sendData
            });
            setData(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };

    const [searchParams, setSearchParams] = useState({
        iemId: '',
        detailSn: '',
        operKndCd: '', //구분
        cdNm: '', //위원회(회의)명
        opmtDt: '',//개최일자
        emtInsttCd: '', //기관명
        dcCn: '',//주요내용
        gnrlRm: '', //비고
        oprtnCo: '',//실시회차
        atdrnCo: '',//참석자 수 
    });

    const isUpdate = sendData.flag === 'update';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setAtchDta(e.target.files[0]);
    };

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                    params: {
                        grdc: 'Y',
                        loca: ''
                    }
                });
                setEmogList(response.data.emogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
        popupData();
    }, []);

    useEffect(() => {
        setSearchParams((prev) => ({
            ...prev,
            iemId: sendData.IEM_ID,
            detailSn: sendData.DETAIL_SN || null,
            operKndCd: data.OPER_KND_CD, //구분
            cdNm: data.CD_NM, //위원회(회의)명
            opmtDt: isUpdate ? data.TR_OPMT_DT : sendData.TR_OPMT_DT,//개최일자
            emtInsttCd: data.EMT_INSTT_CD || sendData.emogcode, //기관명
            dcCn: data.DC_CN,//주요내용
            gnrlRm: data.GNRL_RM || '', //비고
            oprtnCo: data.OPRTN_CO,//실시회차
            atdrnCo: data.ATDRN_CO,//참석자 수 
        }));
        setAtchDta(data.ATCH_DTA);
    }, [data]);


    const del = async () => {
        const confirmMessage = "정말로 삭제하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        try {
            const response = await axios.get("/trmsapi/operrslt/opercmitOperrsltDetailDelete.do", {
                params: sendData.DETAIL_SN,
            });
            console.log(response.data); // TODO: 필요 시 삭제 또는 조건부 출력
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    }

    const save = async () => {
        const requiredFields = [
            { key: 'operKndCd', label: '구분' },
            { key: 'cdNm', label: '위원회(회의)명' },
            { key: 'opmtDt', label: '개최일자' },
            { key: 'emtInsttCd', label: '기관명' },
            { key: 'dcCn', label: '주요내용' },
            { key: 'oprtnCo', label: '실시회차' },
            { key: 'atdrnCo', label: '참석자 수' },
        ];

        for (const field of requiredFields) {
            const value = searchParams[field.key];
            if (value === '' || value === null || value === undefined) {
                alert(`${field.label}을(를) 입력(선택)해야합니다.`);
                return;
            }
            if (['oprtnCo', 'atdrnCo'].includes(field.key)) {
                const numValue = Number(value);
                if (numValue < 0) {
                    alert(`${field.label}에 입력할 수 없는 값입니다.`);
                    return;
                }
            }
        }

        const confirmMessage = sendData.flag === "add" ? "저장하시겠습니까?" : "수정하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);
        if (!confirmed) return;

        const formData = new FormData();
        // searchParams 값들 추가
        Object.entries(searchParams).forEach(([key, value]) => {
            formData.append(key, value);
        });
        // 파일 추가
        if (atchDta) {
            formData.append("atchDta", atchDta); // File 객체
        }
        // 유저 ID 추가
        formData.append("userId", localStorage.getItem("id"));
        try {
            const response = await axios.post(
                "/trmsapi/operrslt/opercmitOperrsltDetailSave.do",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            alert(response.data.resultMessage);
        } catch (error) {
            console.error("데이터 저장 중 오류 발생:", error);
        }
    };


    const download = async () => {
        const ATCH_DTA = data.ATCH_DTA;
        const IEM_ID = data.IEM_ID;
        const DETAIL_SN = data.DETAIL_SN;
        const searchDir = "opercmitOperrslt";

        if (!ATCH_DTA) {
            alert("증빙자료가 없습니다.");
            return;
        }
        const params = new URLSearchParams({
            ATCH_DTA: encodeURIComponent(data.ATCH_DTA),
            IEM_ID,
            DETAIL_SN,
            searchDir
        });
        try {
            const response = await fetch(`/trmsapi/operrslt/opercmitfileDownload.do?${params.toString()}`, {
                method: "GET",
            });

            if (!response.ok) {
                alert("파일을 찾을 수 없습니다.");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = ATCH_DTA;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("파일 다운로드 중 오류 발생:", error);
            alert("다운로드에 실패했습니다.");
        }
    }

    const upload = () => {
        setAtchDta(""); // menu 초기화
        setFileFlag("F");
    }

    return (
        <div className='popup_container bg_tr_bg'>
            <div className='flex justify-between'>
                <h5 className='sub_title m-0 p-0'>운영위원회 운영 실적</h5>
                <div className='flex gap-1'>
                    {isUpdate && (
                        <button onClick={del} title="삭제" className='search_btn bg_co_black justify-self-end'>
                            <Icons.DeleteCircle16w />삭제
                        </button>
                    )}
                    <button onClick={save} title={isUpdate ? '수정' : '저장'} className='search_btn bg_tr_primary justify-self-end'>
                        <Icons.Save16w />{isUpdate ? '수정' : '저장'}
                    </button>
                </div>
            </div>
            <div className='com-search tr_pop_th_bg border-l border-r'>
                <form>
                    <hr className='border-t-2 tr_border_soft' />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="35%" />
                            <col width="10%" />
                            <col width="20%" />
                            <col width="20%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>연번</th>
                                <td>{sendData.IEM_ID || ''}</td>
                                <th>구분</th>
                                <td colSpan={2}>
                                    <select
                                        id="operKndCd"
                                        name="operKndCd"
                                        className='w-full'
                                        value={searchParams.operKndCd}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        <option value="SE01">운영위원회</option>
                                        <option value="SE02">실무운영회의</option>
                                        <option value="SE03">지역외상위원회</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>위원회(회의)명</th>
                                <td>
                                    <input
                                        type="text"
                                        id="cdNm"
                                        name="cdNm"
                                        className='input_style'
                                        value={searchParams.cdNm}
                                        onChange={handleChange}
                                    />
                                </td>
                                <th>증빙자료</th>
                                <td colSpan={fileFlag === 'F' ? 2 : 1}>
                                    {fileFlag === 'F' ? (
                                        <input
                                            type="file"
                                            id="atchDta"
                                            name="atchDta"
                                            onChange={handleFileChange} />
                                    ) : (
                                        <input
                                            type="text"
                                            id="atchDta"
                                            name="atchDta"
                                            className='input_style'
                                            value={atchDta}
                                            readOnly
                                        />)}
                                </td>
                                {fileFlag === 'F' ? '' :
                                    <td>
                                        <div className='flex gap-1'>
                                            <button onClick={upload} className='search_btn bg_tr_primary'><Icons.Upload16w />업로드</button>
                                            <button onClick={download} className='excel_form_down'><Theme.Download16 className='co_black' />다운로드</button>
                                        </div>
                                    </td>
                                }
                            </tr>
                            <tr>
                                <th>개최일자</th>
                                <td>
                                    <input
                                        type="date"
                                        name="opmtDt"
                                        id="opmtDt"
                                        value={searchParams.opmtDt}
                                        onChange={handleChange}
                                    />
                                </td>
                                <th>기관명</th>
                                <td colSpan={2}>
                                    <select
                                        name="emtInsttCd"
                                        id="emtInsttCd"
                                        className='w-full'
                                        value={searchParams.emtInsttCd}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        {emogList.map((hosp) => (
                                            <option key={hosp.emogcode} value={hosp.emogcode}>
                                                {hosp.emogdesc}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>주요내용</th>
                                <td colSpan={4}>
                                    <textarea
                                        id="dcCn"
                                        name="dcCn"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.dcCn}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td colSpan={4}>
                                    <textarea
                                        id="gnrlRm"
                                        name="gnrlRm"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.gnrlRm}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>실시회차</th>
                                <td>
                                    <input
                                        type="number"
                                        id="oprtnCo"
                                        name="oprtnCo"
                                        className='input_style'
                                        value={searchParams.oprtnCo}
                                        onChange={handleChange}
                                    />
                                </td>
                                <th>참석자 수</th>
                                <td colSpan={2}>
                                    <input
                                        type="number"
                                        id="atdrnCo"
                                        name="atdrnCo"
                                        className='input_style'
                                        value={searchParams.atdrnCo}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            {isUpdate && (
                                <tr>
                                    <th>생성일시</th>
                                    <td>{data.TR_CREAT_DT}</td>
                                    <th>수정일시</th>
                                    <td colSpan={2}>{data.TR_UPDT_DT || ''}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </form>
            </div>
        </div >
    );
}

export default OperCmit_popup;
